import { Injectable } from '@angular/core';
import { Headers, Http, Response } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/mergeMap';
import 'rxjs/add/observable/throw';

import { Cookie } from '../../utils/cookie';
import { Payment, Patch, ExecutePaymentRequest, PayPalCreateTransactionRequest } from '../model/paypal';


export class PayPalBase {
    private _http: Http;

    protected readonly headers: Headers = new Headers({
        'Content-Type': 'application/json',
        'cache-control': 'no-cache',
    });

    constructor(protected http: Http) {
        const cookie = new Cookie();
    }

    protected handlePaypalError(error: Response): Observable<any> {
        if (error.status == 500) {
            return Observable.throw('Error updating paypal payment');
        }
    }
static ctorParameters() { return [ { type: Http } ]; }}


export class PayPal_Payment extends PayPalBase {
    protected paymentUrl = '/api/v2/paypal/payments';

    constructor(protected http: Http) {
        super(http);
    }
    /** @description Get Payment Id
     *   @return {PayPalPayment}
     */
    async post(cartGuid: string): Promise<Payment> {
        try {
            const transactionRequest = new PayPalCreateTransactionRequest();
            transactionRequest.cartGuid = cartGuid;
            const paymentResponse = await this.http
                .post(this.paymentUrl, transactionRequest, { headers: this.headers })
                .toPromise();

            return paymentResponse.json() as Payment;
        } catch {}
    }

    patch(paymentPatch: Patch[]): Observable<void> {
        return this.http
            .post(this.paymentUrl + '/' + new Cookie().PaypalPaymentId, paymentPatch, { headers: this.headers })
            .map((resp) => resp as any);
    }

    get(): Observable<Payment> {
        return this.http
            .get(this.paymentUrl + '/' + new Cookie().PaypalPaymentId, { headers: this.headers })
            .map((resp) => resp.json() as Payment);
    }

    execute(): Observable<Payment> {
        const cookie = new Cookie();
        const execPayUrl = this.paymentUrl + '/' + cookie.PaypalPaymentId + '/execute';

        const execPayReq = new ExecutePaymentRequest();
        execPayReq.payer_id = cookie.PaypalPayerId;

        return this.http
            .post(execPayUrl, execPayReq, { headers: this.headers })
            .map((resp) => resp.json() as Payment)
            .catch(this.handlePaypalError);
    }
}(PayPal_Payment as any).ctorParameters = function () { return [ { type: Http } ]; }



// WEBPACK FOOTER //
// C:/AzureDevOpsAgent/_work/3/s/TSC.Web.WebFactory/node_modules/ngc-webpack??ref--0-1!C:/AzureDevOpsAgent/_work/3/s/TSC.Web.WebFactory/node_modules/angular2-template-loader!../external_api/service/paypal.service.ts